import React from "react";
import { DailyProductionTable } from "../../../../components";

const DailyProductionList = () => {
  return (
    <div className="w-full overflow-auto flex flex-1">
      <DailyProductionTable />
    </div>
  );
};

export default DailyProductionList;
